import { Pipe, PipeTransform } from '@angular/core';

import { escapeHtml } from 'src/shared/util/linkify';

/**
 * For free text a user typed that goes into `tidy-text`, which writes its
 * text with `[innerHTML]`: escaping it first shows tags like `<b>` as typed
 * instead of rendering them.
 */
@Pipe({
  name: 'escapeHtml',
  standalone: true,
})
export class EscapeHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value ? escapeHtml(value) : '';
  }
}
